// shell: the words of the frame every visitor sees — navigation, hero,
// search, common words, home sections, cabins — in the six languages the
// site opens in. French and English are the reference (also carried by the
// settings context); the others are the shell only, the pages falling back
// to English until their own tables exist.

export const shellL = {
  en: {
    nav: {
      stays: "Stays", flights: "Flights", flightHotel: "Flight + Hotel",
      cars: "Car Rentals", attractions: "Attractions", taxis: "Airport Taxis", tripGroupe: "Trip Groupe",
      bookings: "My Bookings", account: "My account", admin: "Admin", login: "Sign in", signup: "Register", logout: "Sign out",
      support: "Support", manageBooking: "Manage booking", listProperty: "Become a partner",
      menuExplore: "Explore", menuTrip: "Your trip", menuPrefs: "Preferences", groupTrips: "Group trips", unreadShort: "unread",
    },
    hero: { title: "Where do you want to go?", sub: "Find your flight, choose your stay and explore services for your trip. Compare the options that suit your dates and plans." },
    search: {
      hotels: "Hotels", flights: "Flights", flightHotel: "Flight + Hotel", cars: "Cars",
      destination: "Destination, hotel or airport", checkin: "Check-in", checkout: "Check-out",
      guests: "Guests and rooms", search: "Search",
      from: "From", to: "To", departure: "Departure", return: "Return",
      travelers: "Travelers", cabin: "Cabin class", pickup: "Pick-up location", pickupDate: "Pick-up", returnDate: "Return",
      directOnly: "Direct flights only", roundTrip: "Round trip", oneWay: "One way", multiCity: "Multi-city",
      adults: "Adults", children: "Children", infants: "Infants", rooms: "Rooms", searchFlights: "Search flights",
    },
    common: {
      perNight: "/night", perDay: "/day", from: "From", reviews: "reviews", reserve: "Reserve",
      details: "Details", bookNow: "Book now", loading: "Loading…", noResults: "No results",
      filters: "Filters", price: "Price", stars: "Stars", amenities: "Amenities", clear: "Clear", apply: "Apply",
      seeAvailability: "See availability", selectFlight: "Select flight", freeCancellation: "Free cancellation",
      taxesIncluded: "Includes taxes and fees",
    },
    sections: {
      offers: "Trip ideas", offersSub: "Explore places to stay for your next trip",
      trending: "Destinations to discover", trendingSub: "Find a starting point for your next trip",
      explore: "Explore the world", exploreSub: "These popular destinations have a lot to offer",
      weekend: "Featured stays", weekendSub: "Choose your dates to check availability and prices",
      inspiration: "Travel inspiration", inspirationSub: "Ideas to help you plan your next trip",
    },
    cabin: { economy: "Economy", premium: "Premium Economy", business: "Business", first: "First" },
  },
  fr: {
    nav: {
      stays: "Séjours", flights: "Vols", flightHotel: "Vol + Hôtel",
      cars: "Voitures", attractions: "Activités", taxis: "Taxi aéroport", tripGroupe: "Trip Groupe",
      bookings: "Mes réservations", account: "Mon compte", admin: "Admin", login: "Connexion", signup: "S'inscrire", logout: "Déconnexion",
      support: "Support", manageBooking: "Gérer ma réservation", listProperty: "Devenir partenaire",
      menuExplore: "Explorer", menuTrip: "Votre voyage", menuPrefs: "Préférences", groupTrips: "Voyages de groupe", unreadShort: "non lus",
    },
    hero: { title: "Où voulez-vous aller ?", sub: "Trouvez votre vol, choisissez votre hébergement et découvrez les services pour votre voyage. Comparez les options selon vos dates et vos envies." },
    search: {
      hotels: "Hôtels", flights: "Vols", flightHotel: "Vol + Hôtel", cars: "Voitures",
      destination: "Destination, hôtel ou aéroport", checkin: "Arrivée", checkout: "Départ",
      guests: "Voyageurs et chambres", search: "Rechercher",
      from: "Départ", to: "Destination", departure: "Aller", return: "Retour",
      travelers: "Voyageurs", cabin: "Classe", pickup: "Lieu de prise en charge", pickupDate: "Prise", returnDate: "Retour",
      directOnly: "Vols directs uniquement", roundTrip: "Aller-retour", oneWay: "Aller simple", multiCity: "Multi-villes",
      adults: "Adultes", children: "Enfants", infants: "Bébés", rooms: "Chambres", searchFlights: "Rechercher un vol",
    },
    common: {
      perNight: "/nuit", perDay: "/jour", from: "À partir de", reviews: "avis", reserve: "Réserver",
      details: "Détails", bookNow: "Réserver maintenant", loading: "Chargement…", noResults: "Aucun résultat",
      filters: "Filtres", price: "Prix", stars: "Étoiles", amenities: "Équipements", clear: "Effacer", apply: "Appliquer",
      seeAvailability: "Voir les disponibilités", selectFlight: "Sélectionner ce vol", freeCancellation: "Annulation gratuite",
      taxesIncluded: "Taxes et frais inclus",
    },
    sections: {
      offers: "Idées de séjour", offersSub: "Explorez les hébergements pour votre prochain voyage",
      trending: "Destinations à découvrir", trendingSub: "Trouvez l’inspiration pour votre prochain départ",
      explore: "Explorez le monde", exploreSub: "Ces destinations populaires ont beaucoup à offrir",
      weekend: "Séjours à découvrir", weekendSub: "Choisissez vos dates pour vérifier les disponibilités et les prix",
      inspiration: "Inspiration voyage", inspirationSub: "Des idées pour préparer votre prochain voyage",
    },
    cabin: { economy: "Économie", premium: "Premium Économie", business: "Affaires", first: "Première" },
  },
  es: {
    nav: {
      stays: "Alojamientos", flights: "Vuelos", flightHotel: "Vuelo + Hotel",
      cars: "Alquiler de coches", attractions: "Actividades", taxis: "Taxis al aeropuerto", tripGroupe: "Trip Groupe",
      bookings: "Mis reservas", account: "Mi cuenta", admin: "Admin", login: "Iniciar sesión", signup: "Registrarse", logout: "Cerrar sesión",
      support: "Ayuda", manageBooking: "Gestionar reserva", listProperty: "Hazte socio",
      menuExplore: "Explorar", menuTrip: "Tu viaje", menuPrefs: "Preferencias", groupTrips: "Viajes en grupo", unreadShort: "sin leer",
    },
    hero: { title: "¿A dónde quieres ir?", sub: "Encuentre su vuelo, elija alojamiento y descubra servicios para su viaje. Compare las opciones según sus fechas y preferencias." },
    search: {
      hotels: "Hoteles", flights: "Vuelos", flightHotel: "Vuelo + Hotel", cars: "Coches",
      destination: "Destino, hotel o aeropuerto", checkin: "Llegada", checkout: "Salida",
      guests: "Huéspedes y habitaciones", search: "Buscar",
      from: "Origen", to: "Destino", departure: "Ida", return: "Vuelta",
      travelers: "Viajeros", cabin: "Clase", pickup: "Lugar de recogida", pickupDate: "Recogida", returnDate: "Devolución",
      directOnly: "Solo vuelos directos", roundTrip: "Ida y vuelta", oneWay: "Solo ida", multiCity: "Varios destinos",
      adults: "Adultos", children: "Niños", infants: "Bebés", rooms: "Habitaciones", searchFlights: "Buscar vuelos",
    },
    common: {
      perNight: "/noche", perDay: "/día", from: "Desde", reviews: "opiniones", reserve: "Reservar",
      details: "Detalles", bookNow: "Reservar ahora", loading: "Cargando…", noResults: "Sin resultados",
      filters: "Filtros", price: "Precio", stars: "Estrellas", amenities: "Servicios", clear: "Borrar", apply: "Aplicar",
      seeAvailability: "Ver disponibilidad", selectFlight: "Elegir vuelo", freeCancellation: "Cancelación gratuita",
      taxesIncluded: "Impuestos y tasas incluidos",
    },
    sections: {
      offers: "Ideas para su estancia", offersSub: "Explore alojamientos para su próximo viaje",
      trending: "Destinos por descubrir", trendingSub: "Encuentre inspiración para su próximo viaje",
      explore: "Explora el mundo", exploreSub: "Estos destinos populares tienen mucho que ofrecer",
      weekend: "Alojamientos destacados", weekendSub: "Elija sus fechas para consultar disponibilidad y precios",
      inspiration: "Inspiración para viajar", inspirationSub: "Ideas para preparar su próximo viaje",
    },
    cabin: { economy: "Turista", premium: "Turista Premium", business: "Business", first: "Primera" },
  },
  pt: {
    nav: {
      stays: "Estadias", flights: "Voos", flightHotel: "Voo + Hotel",
      cars: "Aluguer de carros", attractions: "Atividades", taxis: "Táxis do aeroporto", tripGroupe: "Trip Groupe",
      bookings: "As minhas reservas", account: "A minha conta", admin: "Admin", login: "Iniciar sessão", signup: "Registar", logout: "Terminar sessão",
      support: "Ajuda", manageBooking: "Gerir reserva", listProperty: "Torne-se parceiro",
      menuExplore: "Explorar", menuTrip: "A sua viagem", menuPrefs: "Preferências", groupTrips: "Viagens em grupo", unreadShort: "não lidas",
    },
    hero: { title: "Para onde quer ir?", sub: "Encontre o seu voo, escolha o alojamento e descubra serviços para a viagem. Compare as opções de acordo com as suas datas e preferências." },
    search: {
      hotels: "Hotéis", flights: "Voos", flightHotel: "Voo + Hotel", cars: "Carros",
      destination: "Destino, hotel ou aeroporto", checkin: "Check-in", checkout: "Check-out",
      guests: "Hóspedes e quartos", search: "Pesquisar",
      from: "Origem", to: "Destino", departure: "Ida", return: "Volta",
      travelers: "Viajantes", cabin: "Classe", pickup: "Local de levantamento", pickupDate: "Levantamento", returnDate: "Devolução",
      directOnly: "Apenas voos diretos", roundTrip: "Ida e volta", oneWay: "Só ida", multiCity: "Vários destinos",
      adults: "Adultos", children: "Crianças", infants: "Bebés", rooms: "Quartos", searchFlights: "Pesquisar voos",
    },
    common: {
      perNight: "/noite", perDay: "/dia", from: "Desde", reviews: "avaliações", reserve: "Reservar",
      details: "Detalhes", bookNow: "Reservar agora", loading: "A carregar…", noResults: "Sem resultados",
      filters: "Filtros", price: "Preço", stars: "Estrelas", amenities: "Comodidades", clear: "Limpar", apply: "Aplicar",
      seeAvailability: "Ver disponibilidade", selectFlight: "Escolher voo", freeCancellation: "Cancelamento gratuito",
      taxesIncluded: "Impostos e taxas incluídos",
    },
    sections: {
      offers: "Ideias para a sua estadia", offersSub: "Explore alojamentos para a sua próxima viagem",
      trending: "Destinos a descobrir", trendingSub: "Encontre inspiração para a sua próxima viagem",
      explore: "Explore o mundo", exploreSub: "Estes destinos populares têm muito para oferecer",
      weekend: "Alojamentos em destaque", weekendSub: "Escolha as datas para consultar a disponibilidade e os preços",
      inspiration: "Inspiração de viagem", inspirationSub: "Ideias para preparar a sua próxima viagem",
    },
    cabin: { economy: "Económica", premium: "Económica Premium", business: "Executiva", first: "Primeira" },
  },
  ar: {
    nav: {
      stays: "الإقامات", flights: "الرحلات الجوية", flightHotel: "طيران + فندق",
      cars: "تأجير السيارات", attractions: "الأنشطة", taxis: "سيارات أجرة المطار", tripGroupe: "Trip Groupe",
      bookings: "حجوزاتي", account: "حسابي", admin: "الإدارة", login: "تسجيل الدخول", signup: "إنشاء حساب", logout: "تسجيل الخروج",
      support: "المساعدة", manageBooking: "إدارة الحجز", listProperty: "كن شريكاً",
      menuExplore: "استكشف", menuTrip: "رحلتك", menuPrefs: "التفضيلات", groupTrips: "رحلات جماعية", unreadShort: "غير مقروءة",
    },
    hero: { title: "إلى أين تريد الذهاب؟", sub: "ابحث عن رحلتك الجوية واختر إقامتك واكتشف الخدمات المناسبة لسفرك. قارن الخيارات حسب تواريخك وتفضيلاتك." },
    search: {
      hotels: "الفنادق", flights: "الرحلات", flightHotel: "طيران + فندق", cars: "السيارات",
      destination: "الوجهة أو الفندق أو المطار", checkin: "تسجيل الوصول", checkout: "تسجيل المغادرة",
      guests: "الضيوف والغرف", search: "بحث",
      from: "من", to: "إلى", departure: "الذهاب", return: "العودة",
      travelers: "المسافرون", cabin: "الدرجة", pickup: "مكان الاستلام", pickupDate: "الاستلام", returnDate: "الإرجاع",
      directOnly: "رحلات مباشرة فقط", roundTrip: "ذهاب وعودة", oneWay: "ذهاب فقط", multiCity: "وجهات متعددة",
      adults: "البالغون", children: "الأطفال", infants: "الرضّع", rooms: "الغرف", searchFlights: "البحث عن رحلات",
    },
    common: {
      perNight: "/ليلة", perDay: "/يوم", from: "ابتداءً من", reviews: "تقييمات", reserve: "احجز",
      details: "التفاصيل", bookNow: "احجز الآن", loading: "جارٍ التحميل…", noResults: "لا توجد نتائج",
      filters: "الفلاتر", price: "السعر", stars: "النجوم", amenities: "المرافق", clear: "مسح", apply: "تطبيق",
      seeAvailability: "عرض التوفر", selectFlight: "اختر الرحلة", freeCancellation: "إلغاء مجاني",
      taxesIncluded: "شامل الضرائب والرسوم",
    },
    sections: {
      offers: "أفكار للإقامة", offersSub: "اكتشف أماكن إقامة لرحلتك القادمة",
      trending: "وجهات تستحق الاكتشاف", trendingSub: "ابحث عن الإلهام لرحلتك القادمة",
      explore: "استكشف العالم", exploreSub: "هذه الوجهات الشهيرة لديها الكثير لتقدمه",
      weekend: "أماكن إقامة مختارة", weekendSub: "اختر تواريخك للتحقق من الإتاحة والأسعار",
      inspiration: "إلهام السفر", inspirationSub: "أفكار تساعدك على التخطيط لرحلتك القادمة",
    },
    cabin: { economy: "اقتصادية", premium: "اقتصادية ممتازة", business: "رجال الأعمال", first: "الأولى" },
  },
  zh: {
    nav: {
      stays: "住宿", flights: "机票", flightHotel: "机票 + 酒店",
      cars: "租车", attractions: "活动", taxis: "机场出租车", tripGroupe: "Trip Groupe",
      bookings: "我的预订", account: "我的账户", admin: "管理", login: "登录", signup: "注册", logout: "退出",
      support: "帮助", manageBooking: "管理预订", listProperty: "成为合作伙伴",
      menuExplore: "探索", menuTrip: "您的旅程", menuPrefs: "偏好设置", groupTrips: "团体旅行", unreadShort: "条未读",
    },
    hero: { title: "您想去哪里？", sub: "查找航班、选择住宿，探索旅途中需要的服务。按日期和出行偏好比较各项选择。" },
    search: {
      hotels: "酒店", flights: "机票", flightHotel: "机票 + 酒店", cars: "租车",
      destination: "目的地、酒店或机场", checkin: "入住", checkout: "退房",
      guests: "客人和房间", search: "搜索",
      from: "出发地", to: "目的地", departure: "出发", return: "返回",
      travelers: "旅客", cabin: "舱位", pickup: "取车地点", pickupDate: "取车", returnDate: "还车",
      directOnly: "仅直飞", roundTrip: "往返", oneWay: "单程", multiCity: "多程",
      adults: "成人", children: "儿童", infants: "婴儿", rooms: "房间", searchFlights: "搜索航班",
    },
    common: {
      perNight: "/晚", perDay: "/天", from: "起", reviews: "条评价", reserve: "预订",
      details: "详情", bookNow: "立即预订", loading: "加载中…", noResults: "没有结果",
      filters: "筛选", price: "价格", stars: "星级", amenities: "设施", clear: "清除", apply: "应用",
      seeAvailability: "查看空房", selectFlight: "选择航班", freeCancellation: "免费取消",
      taxesIncluded: "含税费",
    },
    sections: {
      offers: "住宿灵感", offersSub: "探索适合下一次旅行的住宿",
      trending: "发现目的地", trendingSub: "为下一次出发寻找灵感",
      explore: "探索世界", exploreSub: "这些热门目的地精彩纷呈",
      weekend: "精选住宿", weekendSub: "选择日期以查看可订情况和价格",
      inspiration: "旅行灵感", inspirationSub: "为下一次旅行提供灵感",
    },
    cabin: { economy: "经济舱", premium: "超级经济舱", business: "商务舱", first: "头等舱" },
  },
};
